import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=5c4b6f2d"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4b6f2d')) {
      api.createRecord('5c4b6f2d', component.options)
    } else {
      api.reload('5c4b6f2d', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=5c4b6f2d", function () {
      api.rerender('5c4b6f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/research/Editor.vue"
export default component.exports